import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=1cf0dd6f"
import script from "./teacherList.vue?vue&type=script&lang=js"
export * from "./teacherList.vue?vue&type=script&lang=js"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=1cf0dd6f&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports